import { defineFcm } from '../shared/factory';

export const FCM_SAP_CTA_ON_PETITION_SHOW = defineFcm('sap_cta_on_petition_show')
	.asBoolean()
	.withDefault(false)
	.toConfig();
